var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConsultoriaColorido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6674 16.3326C5.95215 16.6174 5.95215 17.079 5.6674 17.3638L4.20906 18.8221C3.92431 19.1069 3.46263 19.1069 3.17786 18.8221C2.89311 18.5373 2.89311 18.0757 3.17786 17.7909L4.63619 16.3326C4.92096 16.0478 5.38264 16.0478 5.6674 16.3326Z",
    fill: "#76B900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8549 18.5201C8.13965 18.8049 8.13965 19.2665 7.8549 19.5513L6.39656 21.0096C6.11181 21.2944 5.65013 21.2944 5.36536 21.0096C5.08061 20.7248 5.08061 20.2632 5.36536 19.9784L6.82369 18.5201C7.10846 18.2353 7.57014 18.2353 7.8549 18.5201Z",
    fill: "#883C8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.4799 14.1451C3.76465 14.4299 3.76465 14.8915 3.4799 15.1763L2.02156 16.6346C1.73681 16.9194 1.27513 16.9194 0.99036 16.6346C0.705606 16.3498 0.705606 15.8882 0.99036 15.6034L2.44869 14.1451C2.73346 13.8603 3.19514 13.8603 3.4799 14.1451Z",
    fill: "#FB4747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3785 1.77277C8.45779 3.68963 5.39535 7.09096 3.92328 11.2446L10.7552 18.0768C14.909 16.6046 18.3104 13.5422 20.2273 9.6215L12.3785 1.77277ZM13.9019 9.55646C13.9019 10.7647 12.9225 11.744 11.7144 11.744C10.5062 11.744 9.5269 10.7647 9.5269 9.55646C9.5269 8.34838 10.5062 7.36902 11.7144 7.36902C12.9225 7.36902 13.9019 8.34838 13.9019 9.55646Z",
    fill: "#003F80"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8492 8.18112C21.5431 6.34133 21.9227 4.34742 21.9227 2.26486C21.9227 1.56674 21.88 0.878599 21.7972 0.202866C21.1214 0.120018 20.4333 0.0773621 19.7351 0.0773621C17.6526 0.0773621 15.6587 0.456951 13.8189 1.15071L20.8492 8.18112Z",
    fill: "#003F80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8876 19.2092L13.3862 20.7076C13.8456 21.167 14.6309 20.8416 14.6309 20.1919V17.8386C13.7617 18.3689 12.8446 18.8284 11.8876 19.2092Z",
    fill: "#003F80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79086 10.1122C3.17161 9.15527 3.63107 8.23827 4.16127 7.36902H1.80797C1.15834 7.36902 0.833014 8.15442 1.29236 8.61379L2.79086 10.1122Z",
    fill: "#003F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultoriaColorido);
export default __webpack_public_path__ + "static/media/consultoria-colorido.bdeb8100cc8ba73bf7293993f6d519c7.svg";
export { ForwardRef as ReactComponent };